import { PropsWithChildren } from 'react';
import { PropsWithClassName } from 'src/shared/utils/types/PropsWithClassName';

import { Icon } from '@shared/ui/components/Icon';
import { cn } from '@shared/utils/helpers';

import { SortDirection } from './DataTable.types';

type DataTableSortButtonProps = {
  sort: string;
  currentSort: string;
  onSort: (newSort: string) => void;
};

export function DataTableSortButton({
  sort,
  currentSort,
  className,
  onSort,
  children,
}: PropsWithClassName<PropsWithChildren<DataTableSortButtonProps>>) {
  const [currentSortName, currentSortDirection] = parseSortNameAndDirection(currentSort);

  const isCurrent = sort === currentSortName;

  function toggleSort() {
    if (isCurrent) {
      onSort(`${reverseSortDirection(currentSortDirection) === 'desc' ? '-' : ''}${sort}`);
    } else {
      onSort(sort);
    }
  }

  const icon = isCurrent ? (currentSortDirection === 'asc' ? 'angle-up' : 'angle-down') : 'angle-up';

  return (
    <button type="button" className={cn('inline-flex items-center gap-2', className)} onClick={toggleSort}>
      {children}
      <Icon icon={icon} className={cn('text-gray-400 text-sm translate-y-px', { 'text-indigo-700': isCurrent })} />
    </button>
  );
}

function parseSortNameAndDirection(sort: string): [string, SortDirection] {
  if (sort.startsWith('-')) {
    return [sort.substring(1), 'desc'];
  }

  return [sort, 'asc'];
}

function reverseSortDirection(direction: SortDirection) {
  if (direction === 'asc') {
    return 'desc';
  }

  return 'asc';
}
